import PropTypes from "prop-types";
import {
  InputAdornment,
  styled,
  TextField,
  TextFieldProps,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

const Icon = styled(SearchIcon)(({ theme }) => ({
  color: theme.palette.gray.main,
}));

type IProps = TextFieldProps & {
  label: string;
  value: any;
};

const SearchField = ({ label, value, ...props }: IProps) => {
  return (
    <TextField
      {...props}
      placeholder={label}
      type="search"
      variant="outlined"
      size="small"
      value={value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Icon />
          </InputAdornment>
        ),
      }}
    />
  );
};

SearchField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default SearchField;
